import React, { useState } from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import { Add, Remove } from '@mui/icons-material';

interface FaqQuestionProps {
  question: string;
  answer?: string;
  image?: string; // Optional image prop
  component?: React.ReactNode;
}

const FaqQuestion = ({ question, answer, image, component }: FaqQuestionProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel: boolean) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderAnswer = () => {
    // First split by <br/> tags
    const paragraphs = answer.split('<br/>');

    return paragraphs.map((paragraph, index) => {
      // Then process each paragraph for email links
      const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
      const parts = paragraph.split(emailRegex);

      return (
        <React.Fragment key={index}>
          {parts.map((part, i) => {
            if (emailRegex.test(part)) {
              return (
                <a
                  key={i}
                  href={`mailto:${part}`}
                  style={{ color: 'var(--gentian-blue)', textDecoration: 'underline' }}
                >
                  {part}
                </a>
              );
            }
            return part;
          })}
          {index < paragraphs.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <Accordion
      sx={{ border: '1px solid var(--gentian-black)' }}
      expanded={expanded}
      onChange={handleChange(true)}
    >
      <AccordionSummary
        expandIcon={
          expanded ? (
            <Remove sx={{ color: 'var(--gentian-black)' }} />
          ) : (
            <Add sx={{ color: 'var(--gentian-black)' }} />
          )
        }
      >
        <Typography sx={{ color: 'var(--gentian-black)' }}>{question}</Typography>
      </AccordionSummary>
      {component ? (
        <AccordionDetails>{component}</AccordionDetails>
      ) : (
        <AccordionDetails>
          <Typography sx={{ color: 'var(--gentian-black)' }} align="left">
            {renderAnswer()}
          </Typography>
          {image && (
            <img src={image} alt="" style={{ marginRight: '10px', height: '120px', width: '280px' }} />
          )}
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default FaqQuestion;
